module.exports = __webpack_public_path__ + "img/case5.ffe7c5ce.png";